<template>
  <div class="table-tab u-indent-m-b-45px">
    <div class="a-flex-space-between a-align-items-flex-end u-margin-b-24">
      <h3 class="u-font-size-22 u-color-black u-width-auto u-margin-0">{{$t('form.reports.acceptance-price.title')}}</h3>
      <button class="gui-btn gui-btn--red gui-btn--w-150" @click.prevent="$emit('export')">
        {{$t('buttons.export')}}
      </button>
    </div>
    <section v-maximizable>
    <div class="table-tab__container" style="overflow: auto; outline: none;">
      <table class="table-tab__block table" style="min-width: 1500px" v-columns-resizable>
        <thead class="table-tab__thead">
          <tr class="">
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.acceptance-price.column.nomeclature')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.acceptance-price.column.unit')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.acceptance-price.column.tender-number')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.acceptance-price.column.lot-number')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.acceptance-price.column.owner')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.acceptance-price.column.winner')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.acceptance-price.column.acceptance-date')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" colspan="3">
              {{$t('form.reports.acceptance-price.column.price-for-unit')}}
            </th>
          </tr>
          <tr class="">
            <th class="table-tab__border-right table-tab__border-top table-tab__border-bottom">
              {{$t('form.reports.acceptance-price.column.in-acceptance-currency')}}
            </th>
            <th class="table-tab__border-right table-tab__border-top table-tab__border-bottom">
              {{$t('form.reports.acceptance-price.column.acceptance-currency')}}
            </th>
            <th class="table-tab__border-right table-tab__border-top table-tab__border-bottom">
              {{$t('form.reports.acceptance-price.column.in-byn')}}
            </th>
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
          <template v-for="(row, rowIdx) in report">
            <tr :class="{'table-tab__background-color': rowIdx % 2}">
              <td class="table-tab__border-right">
                {{row.nomenclature}}
              </td>
              <td class="table-tab__border-right">
                {{row.measure}}
              </td>
              <td class="table-tab__border-right">
                {{row.tenderNum}}
              </td>
              <td class="table-tab__border-right">
                {{row.lotNum}}
              </td>
              <td class="table-tab__border-right">
                {{row.organizer}}
              </td>
              <td class="table-tab__border-right">
                {{row.winner}}
              </td>
              <td class="table-tab__border-right">
                <date-time :time="false" :value="row.dateAccept" placeholder=""></date-time>
              </td>
              <td class="table-tab__border-right">
                {{row.price}}
              </td>
              <td class="table-tab__border-right">
                {{row.currency}}
              </td>
              <td class="table-tab__border-right">
                {{row.priceByn}}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: {
      report: Array
    }
  }
</script>

<style scoped>

</style>
